"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var UnauthorisedNotifier = function (showAcknowledgeModal, createUi, apiBaseUrl) {
    axios_1.default.interceptors.response.use(function (response) { return response; }, function (error) {
        var _a, _b;
        var response = error.response;
        var errorMessage = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.message;
        if (response.status === 401 && response.config.url.startsWith(apiBaseUrl)) {
            showAcknowledgeModal({
                title: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "Your session has expired",
                explainer: createUi(require("../../ErrorCatcher/UnauthorizedModalText.html")),
                button: "Log back in",
            }).then(function (result) {
                if (result) {
                    window.location.href = window.location.origin;
                }
            });
        }
        return Promise.reject(error);
    });
};
exports.default = UnauthorisedNotifier;
